// extracted by mini-css-extract-plugin
export default {"transfer":"MarginDialog_transfer__17nx3"};